import React from 'react';

export const WaitingIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#a)" stroke="currentColor" strokeWidth="1.084">
                <path d="M1 6a5 5 0 1 0 5-5 5.562 5.562 0 0 0-3.846 1.538" />
                <path d="m2.538 1-.384 1.538 1.538.385M6 3.308v3.077l-2 1" />
            </g>
            <defs>
                <clipPath id="a">
                    <path d="M0 0h12v12H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
